var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"bigImage-floating",on:{"click":function($event){_vm.show = false}}},[_c('img',{attrs:{"src":_vm.url},on:{"click":function($event){$event.stopPropagation();}}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }